/**
 * Ficha Enrich — carga modular de bloques enriquecidos por AJAX.
 * Una petición por bloque (data-block). Estilo Drivim.
 */
(function ($) {
    'use strict';

    $(function () {
        if (typeof mgEnrich === 'undefined') { return; }

        // Puede haber varios contenedores .mg-enrich en la página
        $('.mg-enrich').each(function () {
            var $root     = $(this);
            var vehicleId = parseInt($root.attr('data-vehicle-id'), 10) || 0;
            var simulate  = parseInt($root.attr('data-simulate'), 10) ? 1 : 0;

            if (!vehicleId && !simulate) { return; }

            $root.find('.mg-enrich-block').each(function () {
                var $block = $(this);
                var name   = $block.attr('data-block');

                $.ajax({
                    url: mgEnrich.ajaxurl,
                    method: 'POST',
                    dataType: 'json',
                    data: {
                        action: 'mg_enrich_block',
                        nonce: mgEnrich.nonce,
                        vehicle_id: vehicleId,
                        block: name,
                        simulate: simulate
                    }
                }).done(function (res) {
                    if (res && res.success && res.data && res.data.html) {
                        $block.html(res.data.html).removeAttr('hidden');
                        initEquipCollapse($block[0]);
                    }
                });
            });
        });

        // Equipamiento renderizado server-side (sin AJAX)
        initEquipCollapse(document);
    });

    /* ---------------------------------------------------------------------
     * Equipamiento plegado en mobile (<=768px)
     * Los <details.mg-acc> se renderizan con `open` (desktop intacto). En
     * mobile los cerramos, salvo que el usuario los haya abierto a mano.
     * ------------------------------------------------------------------- */
    var EQUIP_MQ = '(max-width: 768px)';

    function applyEquipCollapse(root) {
        var isMobile = window.matchMedia(EQUIP_MQ).matches;
        var list = (root || document).querySelectorAll('.mg-equip details.mg-acc');
        Array.prototype.forEach.call(list, function (d) {
            if (d.getAttribute('data-mg-user-toggled')) { return; }
            if (isMobile) { d.removeAttribute('open'); }
            else          { d.setAttribute('open', ''); }
        });
    }

    function initEquipCollapse(root) {
        var list = (root || document).querySelectorAll('.mg-equip details.mg-acc');
        Array.prototype.forEach.call(list, function (d) {
            var s = d.querySelector('summary');
            if (s && !s.getAttribute('data-mg-bound')) {
                s.setAttribute('data-mg-bound', '1');
                // click real del usuario (no salta en cambios programáticos de `open`)
                s.addEventListener('click', function () { d.setAttribute('data-mg-user-toggled', '1'); });
            }
        });
        applyEquipCollapse(root);
    }

    // Reevaluar al cambiar de viewport (reset de la marca manual para que
    // el plegado/desplegado aplique en ambos sentidos al cruzar el breakpoint).
    var _mgResizeT;
    window.addEventListener('resize', function () {
        clearTimeout(_mgResizeT);
        _mgResizeT = setTimeout(function () {
            var list = document.querySelectorAll('.mg-equip details.mg-acc');
            Array.prototype.forEach.call(list, function (d) { d.removeAttribute('data-mg-user-toggled'); });
            applyEquipCollapse(document);
        }, 200);
    });

})(jQuery);
